import React, { useContext } from 'react';
import Img from 'gatsby-image';
import { findT } from '@interness/web-core/src/components/_helpers';
import Button from '@interness/web-core/src/components/elements/Button/Button';
import Link from '@interness/web-core/src/components/elements/Link/Link';
import useDisplayBrands from '@interness/brands-addon/src/hooks/useDisplayBrands';
import routes from '@interness/web-core/config/routes';
import { LanguageContext } from '@interness/web-core/src/providers';
import { getRandomBrandImage } from '@interness/brands-addon/src/components/_helpers';
import * as S from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Display = _ref => {
  let {
    exclude,
    order
  } = _ref;
  const {
    displayTypes,
    brands
  } = useDisplayBrands(exclude, order);
  const {
    language
  } = useContext(LanguageContext);
  return ___EmotionJSX(S.Container, null, displayTypes.map(displayType => {
    const translations = findT(displayType.translations, 'de');
    const brand = getRandomBrandImage(brands.nodes, displayType.type);
    return ___EmotionJSX(S.Item, {
      colCount: displayTypes.length,
      key: displayType.type
    }, ___EmotionJSX("div", null, ___EmotionJSX(Img, {
      fluid: brand.header_images[0].file.localFile.childImageSharp.fluid,
      alt: brand.display_name
    }), ___EmotionJSX("h4", null, translations.display_name), ___EmotionJSX("h5", null, translations.subtitle), ___EmotionJSX("p", {
      dangerouslySetInnerHTML: {
        __html: translations.short_description
      }
    })), ___EmotionJSX(Button, {
      as: Link,
      to: routes[displayType.type][language]
    }, "Mehr erfahren"));
  }));
};
Display.defaultProps = {
  exclude: [''],
  order: ['']
};
export default Display;